export default {"src":"/_next/static/media/Magic wand.63a78c21.svg","height":20,"width":20};